<template>
  <div
    :class="[
      'column position-relative',
      colType,
      {
        question: cell.isQuestion,
        answer: cell.isAnswer,
        placeholder: cell.isAnswer && !cell.answer_id,
        active: cell.active,
        warning: hasQuestion,
      },
    ]"
    :style="{
      height: `${cell.height}%`,
      'background-color': cell.isQuestion ? cell.settings.background : null,
    }"
    v-if="!cell.hide"
    @click.stop="onClick(cell)"
    @dblclick.stop="onDblClick(cell)"
    :data-positiony="cell.positiony"
    :data-positionx="cell.positionx"
    :data-question="hasQuestion"
  >
    <template v-if="showQuestionTemplate">
      <svg
        class="question-svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 64 64"
      >
        <path
          d="M10 6h44a6 6 0 016 6v28a6 6 0 01-6 6H26L14 56v-10h-4a6 6 0 01-6-6V12a6 6 0 016-6z"
          fill="none"
          stroke="currentColor"
          stroke-width="4"
          stroke-linejoin="round"
        />
      </svg>
    </template>
    <template v-else-if="cell?.children?.length > 0 && showText">
      <puzzle-cell
        v-for="c_cell in cell.children"
        :key="c_cell.positiony + c_cell.positionx"
        :cell="c_cell"
      />
    </template>
    <template v-else>
      <!-- <div class="number" v-if="showNumbers">{{ cell.positiony }}{{ cell.positionx }}</div> -->
      <input
        autocomplete="off"
        type="text"
        length="1"
        class="cell-input"
        v-if="!cell.answer_id && showText && (cell.text || cell.text == '')"
        v-model="cell.text"
        @focus="$event.target.select()"
        @keyup="changeLetter(cell)"
      />
      <p
        v-else-if="showText"
        :style="{
          fontWeight: 'bold',
          fontSize: !cell.isAnswer ? `${cell.settings?.font_size}px` : null,
        }"
      >
        {{ cell.text }}
      </p>
    </template>
    <div
      v-if="cell.arrow_position && cell.arrow_position.slug && showText"
      :class="['arrow', `position_${cell.arrow_position.slug}`]"
    >
      <div
        v-if="cell.arrow_direction && cell.arrow_direction.slug"
        :class="['arrow', `direction_${cell.arrow_direction.slug}`]"
      ></div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import {
  CELL,
  _PUZZLE_GROUP_OPTION_,
  _PUZZLE_SELECTED_CELL_,
} from './PuzzleModel';

export default {
  name: 'puzzle-cell',
  props: {
    cell: {
      type: Object,
      require: true,
    },
    templateMode: {
      type: Boolean,
      default: false,
    },
    isPlanningMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasQuestion() {
      if (
        this.cell.answer &&
        this.cell.question &&
        this.cell.answer_id !== null &&
        (this.cell.text === '' || this.cell.text === null)
      ) {
        return true;
      }
      return false;
    },
    showQuestionTemplate() {
      if (this.cell.isQuestion && this.templateMode) return true;

      return this.cell.isQuestion && this.isPlanningMode && !this.hasQuestion;
    },
    showNumbers() {
      if (
        process.env.NODE_ENV === 'production' ||
        this.$store.state.puzzle.print
      ) {
        return false;
      }
      return true;
    },
    selectedCell() {
      const { puzzleCell } = this.$store.state.puzzle;
      if (puzzleCell) {
        return puzzleCell;
      }
      return cloneDeep(CELL);
    },
    colType() {
      const types = {
        col: 'column',
        row: 'line',
        colspan: 'colspan',
        rowspan: 'rowspan',
        row_rowspan: 'rowspan line',
        colspan_row: 'colspan line',
        colspan_col: 'colspan colspan_col',
      };
      return types[this.cell.type];
    },
    showText() {
      if (this.$store.state.puzzle.print) {
        if (this.$store.state.puzzle.printAnswer) {
          if (this.cell.isAnswer) {
            return true;
          }
          return false;
        }
        if (this.$store.state.puzzle.printQuestion) {
          if (!this.cell.isAnswer) {
            return true;
          }
          return false;
        }
      }
      return true;
    },
  },
  methods: {
    onClick(cell) {
      if (!this.templateMode && !this.isPlanningMode) this.selectCell(cell);
    },
    onDblClick(cell) {
      if (this.templateMode || this.isPlanningMode) this.toggleQuestion(cell);
    },
    selectCell(cell) {
      cell.active = !cell.active;
      if (this.selectedCell.active) {
        Events.$emit(_PUZZLE_GROUP_OPTION_, cell);
        return cell;
      }
      Events.$emit(_PUZZLE_SELECTED_CELL_, cell);
      return cell;
    },
    toggleQuestion(cell) {
      cell.isQuestion = !cell.isQuestion;
      cell.updated = true;
      this.$forceUpdate();
    },
    changeLetter(cell) {
      cell.text = cell.text ? cell.text.toUpperCase() : '';
    },
    reRender() {
      this.$forceUpdate();
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.number {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 10px;
  font-weight: normal;
}
.cell-input {
  border: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  color: #bbb;
  font-weight: bold;
}

.question-svg {
  color: #000;
}
</style>
